import Text from '../Text/Text';
import Tooltip from './Tooltip';

export type AprBreakdownTooltipProps = {
	symbol: string;
	depositAprPercent: number;
	marketAprBreakdowns: Array<{
		source: string;
		apr: number;
	}>;
	children: React.ReactNode;
};

const AprBreakdownRow = (props: { source: string; apr: number }) => {
	return (
		<div className="flex items-center justify-between w-full">
			<span>{props.source}</span>
			<span className="text-positive-green">{props.apr}%</span>
		</div>
	);
};

const AprBreakdownTooltip = ({
	symbol,
	depositAprPercent,
	marketAprBreakdowns,
	children,
}: AprBreakdownTooltipProps) => {
	return (
		<Tooltip
			allowHover={symbol === 'mSOL'}
			content={
				<div
					className={`flex flex-col ${
						symbol === 'mSOL' ? 'w-[180px]' : 'w-[170px]'
					}`}
				>
					<AprBreakdownRow
						source="Lending"
						apr={+depositAprPercent.toFixed(2)}
					/>
					{marketAprBreakdowns.map((breakdown) => (
						<AprBreakdownRow
							key={breakdown.source}
							source={breakdown.source}
							apr={+breakdown.apr.toFixed(2)}
						/>
					))}
					{symbol === 'mSOL' && (
						<div className="mt-2 flex flex-col items-start space-y-1">
							<Text.BODY3 className="font-bold">
								Eligible for MNDE rewards
							</Text.BODY3>
							<Text.BODY3>
								Learn more on{' '}
								<a
									href="https://marinade.finance/app/rewards/"
									target="_blank"
									rel="noreferrer"
								>
									Marinade earn
								</a>
							</Text.BODY3>
						</div>
					)}
				</div>
			}
		>
			{children}
		</Tooltip>
	);
};

export default AprBreakdownTooltip;
